import { Breadcrumb } from 'antd';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBreadcrumbContext } from './NavBreadcrumbContext';

const NavBreadcrumb = () => {
  const { items } = useContext(NavBreadcrumbContext);
  const navigate = useNavigate();

  const itemRender = (currentRoute: any, _params: any, allItems: any) => {
    const isLast = currentRoute?.path === allItems[allItems.length - 1]?.path;
    if (isLast || !currentRoute?.path) {
      return <span className="font-figtree">{currentRoute.title}</span>;
    }
    return (
      <button
        type="button"
        className="font-figtree cursor-pointer text-muted-foreground hover:text-[#000032] bg-transparent border-0 p-0 font-inherit"
        onClick={() => navigate(currentRoute.path)}
      >
        {currentRoute.title}
      </button>
    );
  };

  return <Breadcrumb data-testid="nav-breadcrumb" itemRender={itemRender} items={items} />;
};

export default NavBreadcrumb;
